import './single';

import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import './gallery-slider';
import './post-slider';
